import { useSelector } from 'react-redux';
import { RootState } from '~/redux-toolkit/store/store';
import { toggleCompareCarId } from '~/redux-toolkit/slices/compareSlice';
import { CompareCarTypeEnum } from '~/data/types/compare/compareTypes';
import { useAppDispatch } from '~/redux-toolkit/store/hooks';

const useCompareCars = () => {
  const dispatch = useAppDispatch();
  const { usedCarComparison, newCarComparison, leasingComparison } =
    useSelector((state: RootState) => state.compare);

  const toggleCarInCompare = (car: any, type: CompareCarTypeEnum) => {
    dispatch(toggleCompareCarId({ car, type }));
  };

  return {
    usedCarComparison,
    newCarComparison,
    leasingComparison,
    toggleCarInCompare,
  };
};

export default useCompareCars;
